/* ***************************************************************** */
/*                                                                   */
/* Licensed Materials - Property of IBM                              */
/*                                                                   */
/* (C) Copyright IBM Corp. 2022                                      */
/*                                                                   */
/* ***************************************************************** */

import {userService} from "../../services";
import {get, immutable_set} from "../../utils";
import {handleError} from "../../utils/internal-error-handler";
import {makeQuickClearStateAction} from "../DrugPointsPage2/drug-points-utils";
import {makeClearIndepthState} from "../InDepthPage2/in-depth-utils";
import {
    makeDrugInteractionClearStateAction,
    makeDrugInteractionSearchClearStateAction,
    makeInteractionDetailsClearStateAction
} from "../DrugInteractionPage/drug-interaction-utils";
import {makeIvCompatSearchClearStateAction} from "mdx-ivcomp-common-ui/dist/src/pages/IVCompatibilityPages/iv-compatibility-search-page/iv-compatibility-search-utils";
import {makeIVCompatSummaryClearStateAction} from "mdx-ivcomp-common-ui/dist/src/pages/IVCompatibilityPages/iv-compatibility-summary-page/iv-compatibility-summary-utils";
import {makeIVDetailsClearStateAction} from "mdx-ivcomp-common-ui/dist/src/pages/IVCompatibilityPages/iv-details-page/iv-details-utils";
import {makeIVProductInfoClearStateAction} from "mdx-ivcomp-common-ui/dist/src/pages/IVCompatibilityPages/iv-product-info-page/iv-product-info-utils";
import {makeFilterReduxClearStateAction} from "mdx-ivcomp-common-ui/dist/src/components/checkbox-filter/filter-redux/filter-redux.js";
import {makeChatClearStateAction} from "../ChatbotPage/chatbot-utils";
import {makeLoginClearStateAction} from "../LoginPage/login-page-redux";
import {makeClearTokenAuthenticationState} from "../GatewayPage/gateway-page-redux";
import {makeClearIpAuthenticationState} from "../IpLoginPage/ip-login-page-redux";
import {makeDrugConsultsClearStateAction} from "../DrugConsultsPage/drug-consults-utils";
import {makeClearCommonOverflowState} from "../../components/common-overflow-menu/common-overflow-redux";
import {makeSetUnsubscribedModuleAction} from "../../components/subscription/subscription-notification-redux";
import {GENERIC_ERROR_MESSAGE} from "../../components/common/constants";
import {trackLogout} from "../../utils/analytics-tracker-utils";
import {makeRelatedResultsClearStateAction} from "../../components/related-results/redux/related-results-redux";
import {makeDeleteUrlParametersAction} from "../../components/common/url-params-redux";
import {makeClearInlineLoadingStateAction} from "../../components/response-loading/redux/response-loading-redux";
import {makeClearHomePageStateAction} from "../HomePage/home-page-utils";import {clearNeofaxPediatricsSearchState} from "../NeoFaxPediatricsPage/pages/DrugMonographs/SearchPage/redux/neofax_search_redux";
import {clearNeoPedMonographState} from "../NeoFaxPediatricsPage/pages/DrugMonographs/MonographPage/redux/neoped_monograph_redux";
import {makeClearFormulaSearchState} from "../NeoFaxPediatricsPage/pages/EnteralFormulas/SearchPage/redux/formula_search_redux";
import {
    clearProductNotesState
} from "../NeoFaxPediatricsPage/pages/EnteralFormulas/ProductNotesPage/redux/enteral_formula_product_notes_redux";
import {
    clearNutrientDetailsState
} from "../NeoFaxPediatricsPage/pages/EnteralFormulas/NutrientDetailsPage/redux/nutrient_details_redux";

/**
 * For each reducer in combined_reducer,
 * dispatch the corresponding clear state action
 * @returns {function(...[*]=)}
 */
export function makeGlobalClearStateThunk() {
    console.debug('makeGlobalClearStateThunk: ENTER');

    return (dispatch, getState) => {
        dispatch(makeClearHomePageStateAction())

        dispatch(makeDrugInteractionClearStateAction())
        dispatch(makeInteractionDetailsClearStateAction())
        dispatch(makeDrugInteractionSearchClearStateAction())

        dispatch(makeIvCompatSearchClearStateAction())
        dispatch(makeIVCompatSummaryClearStateAction())
        dispatch(makeIVDetailsClearStateAction())
        dispatch(makeIVProductInfoClearStateAction())

        dispatch(makeChatClearStateAction())
        dispatch(makeQuickClearStateAction())
        dispatch(makeClearIndepthState())

        dispatch(makeLoginClearStateAction())
        dispatch(makeClearTokenAuthenticationState())
        dispatch(makeClearIpAuthenticationState())

        dispatch(makeClearCommonOverflowState())
        dispatch(makeSetUnsubscribedModuleAction(''))
        dispatch(makeDrugConsultsClearStateAction())
        dispatch(makeRelatedResultsClearStateAction())
        dispatch(makeDeleteUrlParametersAction())
        dispatch(makeClearInlineLoadingStateAction())
        dispatch(makeFilterReduxClearStateAction())
        dispatch(clearNeofaxPediatricsSearchState())
        dispatch(clearNeoPedMonographState())
        dispatch(makeClearFormulaSearchState())
        dispatch(clearProductNotesState())
        dispatch(clearNutrientDetailsState())
    }
}


const defaultLogoutPageState = {
}

// Action constants
export const A = {
    SET_LOGOUT_STATE: 'SET_LOGOUT_STATE',
    SET_ERROR_MESSAGE: 'SET_ERROR_MESSAGE',
    SET_IS_RELOGIN_STATE: 'SET_IS_RELOGIN_STATE'
}
export function makeLogoutAction(response) {
    return {
        type: A.SET_LOGOUT_STATE
    }
}
export function makeSetErrorMessageAction(errorMessage='') {
    return {
        type: A.SET_ERROR_MESSAGE,
        errorMessage
    }
}

export function makeSetReloginStateAction(reloginState = false) {
    return {
        type: A.SET_IS_RELOGIN_STATE,
        reloginState
    }
}

//Reducers

export function updateSetLogoutReducer( action={}) {
    let new_state = {}
    return new_state;
}
export function updateSetErrorMessageReducer(current_state={}, action={}) {
    let new_state =  immutable_set(
        current_state,
        'errorMessage',
        action.errorMessage
    )
    return new_state;
}

export function setIsReloginStateReducer(current_state={}, action={}) {
    return immutable_set(
        current_state,
        'isReloginState',
        action.reloginState
    )
}

export function logout_page(
    current_state=defaultLogoutPageState,
    action={}
) {
    switch (action.type) {
        case A.SET_LOGOUT_STATE:
            return updateSetLogoutReducer(action)
        case A.SET_ERROR_MESSAGE:
            return updateSetErrorMessageReducer(current_state, action)
        case A.SET_IS_RELOGIN_STATE:
            return setIsReloginStateReducer(current_state, action)
        default:
            return current_state
    }
}

// redux-thunk THUNKs
export function makeLogoutThunk(logoutPageProps={}) {
    return (dispatch,getState) => {
        trackLogout();
        userService.logout(logoutPageProps, get(getState(), 'login_page.mdxAuthenticationJson.Set-Cookie', ''))
            .then(function (result) {
                let current_state = getState();
                console.debug('current state in side logout Thunk :',current_state);
                dispatch(makeGlobalClearStateThunk())
                current_state = getState();
                console.debug('After clearing current state in side logout Thunk :',current_state)

                // Entra users: after the application-layer session is cleared, complete sign-out at
                // the Entra (federated) layer by navigating the browser to the end-session URL.
                const entraLogoutUrl = get(result, 'entraLogoutUrl', '');
                if (entraLogoutUrl) {
                    window.location.assign(entraLogoutUrl);
                    return;
                }

                //Logout here
                logoutPageProps.history.push("/login");

            }).catch((err)=> {
            console.error("Logout failed.",err); // TODO: better error handling/logging
            handleError({props: logoutPageProps, message:GENERIC_ERROR_MESSAGE, dispatch},
              makeSetErrorMessageAction(err));
            return;
        });
    }
}